import React, { useEffect, useRef, useState } from "react";
import { printWithOrientation, subscribePrintOrientation } from "../utils/printOrientation";
import "./PrintActions.css";

export default function PrintActions({ disabled = false, onPrint, floating = false, className = "" }) {
    const [printing, setPrinting] = useState(false);
    const [pending, setPending] = useState(false);
    const [error, setError] = useState("");
    const [noticeHeight, setNoticeHeight] = useState(0);
    const ownCleanup = useRef(null);
    const mounted = useRef(true);
    const pendingRequest = useRef(null);
    useEffect(() => {
        mounted.current = true;
        const unsubscribe = subscribePrintOrientation(state => setPrinting(state.printing));
        return () => {
            mounted.current = false;
            pendingRequest.current = null;
            unsubscribe();
            if (ownCleanup.current) ownCleanup.current();
        };
    }, []);
    useEffect(() => {
        if (!floating) return;
        let notice;
        const measure = () => setNoticeHeight(notice ? Math.ceil(notice.getBoundingClientRect().height) : 0);
        const resize = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
        const observe = () => {
            const current = document.getElementById("eduprime-qa-notice");
            if (current === notice && resize) return;
            if (resize) resize.disconnect();
            notice = current;
            if (notice && resize) resize.observe(notice);
            measure();
        };
        observe();
        const mutation = typeof MutationObserver === "undefined" ? null : new MutationObserver(observe);
        if (mutation) mutation.observe(document.body, { childList: true });
        window.addEventListener("resize", measure);
        return () => {
            if (resize) resize.disconnect();
            if (mutation) mutation.disconnect();
            window.removeEventListener("resize", measure);
        };
    }, [floating]);
    const print = async (orientation, event) => {
        if (disabled || printing || pendingRequest.current) return;
        const request = {};
        pendingRequest.current = request;
        const isCurrent = () => mounted.current && pendingRequest.current === request;
        setPending(true);
        setError("");
        try {
            const cleanup = await (onPrint ? onPrint(orientation, event, isCurrent) : printWithOrientation(orientation));
            if (typeof cleanup === "function") {
                if (isCurrent()) ownCleanup.current = cleanup;
                else cleanup();
            }
        } catch (_) {
            if (isCurrent()) setError("Laporan belum dapat dicetak. Muat ulang lalu coba lagi.");
        } finally {
            if (isCurrent()) {
                pendingRequest.current = null;
                setPending(false);
            }
        }
    };
    return <div className={`eduprime-print-actions${floating ? " eduprime-print-actions-floating" : ""}${className ? ` ${className}` : ""}`}
        role="group" aria-label="Pilihan cetak laporan" style={floating ? { "--print-action-notice-height": `${noticeHeight}px` } : undefined}>
        <button type="button" className="eduprime-print-button" disabled={disabled || printing || pending} onClick={event => print("portrait", event)}>Cetak Portrait</button>
        <button type="button" className="eduprime-print-button" disabled={disabled || printing || pending} onClick={event => print("landscape", event)}>Cetak Landscape</button>
        {error && <p className="eduprime-print-message" role="alert">{error}</p>}
    </div>;
}
